<template>
  <v-row
    :align="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
    :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'start'"
    class="py-6 py-md-12 mx-0"
    data-aos="zoom-in-up"
    data-aos-easing="linear"
    data-aos-duration="5000"
  >
    <v-col cols="12" md="8" class="mb-6">
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'text-center primary--text' : 'primary--text'">Permítenos resolver tus dudas</h1>
    </v-col>
    <v-col cols="10" lg="10">
      <v-expansion-panels flat>
        <v-expansion-panel
          v-for="(item, i) in questions"
          :key="i"
          class="border"
        >
          <v-expansion-panel-header class="font-weight-bold font-italic">
            {{ item.q }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ item.r }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>
<style scoped>
.border {
  border: 1px solid #88888866;
  margin-bottom: 1rem;
}
</style>

<script>
export default {
  name: "FAQ",
  data: () => ({
    questions: [
      {
        q: "¿Puedo inscribirme en línea?",
        r: "Claro que sí, contamos con distintas formas de inscripción a distancia, solo necesitas completar el formulario y empezar tu proceso de inscripción.",
      },

      {
        q: "¿Cuentan con convenios nacionales e internacionales? ",
        r: "Nos interesa fortalecer tus conocimientos, por ello desarrollamos tus habilidades en empresas nacionales e internacionales por medio de nuestro programa #vizcayaporelmundo, lo que te hará descubrir nuevas posibilidades de crecimiento.",
      },

      {
        q: "¿Cuentan con sistema de becas y apoyos socioeconómicos?",
        r: "Tus sueños nos importan y para verte realizarlos te ofrecemos distintos tipos de becas y  convenios con instituciones publicas y privadas que te permitirán tener acceso a una educación de calidad sin sacrificar tu economía.",
      },

      {
        q: "Sí trabajo, ¿cuáles son las modalidades que tienen disponibles?",
        r: "Nuestra educación está diseñada para todo aquél que desee superarse, por lo que contamos con distintas modalidades de estudio que se adaptan a tu estilo de vida, y la opción de estudiar en nuestra Universidad en línea.",
      },

      {
        q: "En Vizcaya, ¿cómo aplicas la teoría?",
        r: "Impulsamos tus habilidades profesionales gracias a nuestras actividades con simuladores, talleres y laboratorios especializados en un ambiente interactivo que te permitirá reforzar tus áreas de oportunidad. ",
      },
    ],
  }),
};
</script>